import React from 'react'
import moment from 'moment'

import {
    to12Hr
} from '../../../helpers/moment'

const WeeklyShiftAssigned = ({ notification }) => {

    return (
        <div className="container">
            <div className="py-4 text-muted text-center" style={{ fontSize: '0.8rem' }}>{moment(notification.createdAt).fromNow()}, {to12Hr(moment(notification.createdAt))}</div>
            <h5>{notification.title}</h5>
            {/* <div>
                Your preferred shifts for next week are assigned! Please check it out.
            </div> */}
        </div>
    )
}

export default WeeklyShiftAssigned